import { ValueComponent } from "components/components/Component";
import { SimpleOutputBaseDefinition, SimpleOutputBaseComponent } from "components/output/baseOutputDefinition";
import i18n from "components/i18n/i18n";
import { I18nMessageDefinition } from "components/i18n/I18nMessage";
import template from "components/output/text/text.hbs";
import { TextOutputElement } from "components/output/text/textElement";

export class TextOutput extends SimpleOutputBaseComponent<TextOutputDefinition> implements ValueComponent {

    public readonly componentType: string = "textOutput";

    private element: TextOutputElement;
    private codeTranslate: string | I18nMessageDefinition;

    constructor(schema: TextOutputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        return this.view;
    }

    public renderTemplate(): Element {
        let objStyle: any = this.generateSytleAttribute();
        return super.renderTemplate(template, objStyle);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-text-output");

        this.genericBindEvents(this.element);
    }

    public getValue(): string | I18nMessageDefinition {
        if (this.definition.translate) {
            return this.codeTranslate;
        } else {
            return this.element.data;
        }
    }

    public value(v: string | I18nMessageDefinition) {
        let text = null;
        if (this.definition.translate) {
            this.codeTranslate = v;
            text = i18n.t(v);
        } else {
            text = v;
        }
        this.element.data = text;
    }
}

export interface TextOutputDefinition extends SimpleOutputBaseDefinition {
    translate?: boolean;
    styleMaxWidth_ch?: number;
}
